import { Button, Form, Input, message } from 'antd';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../app/hooks';
import { selectUser } from '../../../../auth/states/userSlice';
import { setModal } from '../../../../common/slices/commonSlice';
import { toasterNotification } from '../../../../common/utils/ToasterNotification';
import { useCreateDepartmentMutation } from '../endpoints/departmentEndpoints';
import { IDepartmentFormData } from '../types/departmentTypes';
import LoadingIndicator from '../../../../components/common/spinner/LoadingIndicator';

const DepartmentsAddModal = ({ department }: { department: string[] }) => {
  const dispatch = useAppDispatch();
  const user = useSelector(selectUser);

  const [form] = Form.useForm();
  const [addDepartment, { isError, isSuccess, isLoading }] =
    useCreateDepartmentMutation();
  useEffect(() => {
    if (isSuccess) {
      message.success('Department Added Successfully');
    } else if (isError) {
      message.error('Something went wrong');
    }
  }, [isSuccess, isError]);

  const handleSubmit = async (values: IDepartmentFormData) => {
    const body: IDepartmentFormData = {
      ...values,
      department_created_by: user?.user_id as number,
    };
    await addDepartment(body);
    dispatch(setModal(false));
    form.resetFields();
  };
  const layout = {
    labelCol: { span: 9 },
    wrapperCol: { span: 16 },
  };
  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      layout='horizontal'
      labelAlign='left'
      {...layout}
    >
      <Form.Item
        label='Department name'
        name='department_name'
        rules={[
          { required: true, message: 'Please input department name!' },
          { max: 65, message: 'Maximum 65 characters' },
          {
            validator(_, value) {
              if (value) {
                if (department.includes(value)) {
                  return Promise.reject('Department Name is already Exist');
                } else {
                  return Promise.resolve();
                }
              } else {
                return Promise.resolve();
              }
            },
          },
        ]}
      >
        <Input placeholder='Enter department name' />
      </Form.Item>

      <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 9 }}>
        <Button
          type='primary'
          htmlType='submit'
          loading={isLoading}
        >
          Submit
        </Button>
      </Form.Item>
      {isLoading && <LoadingIndicator />}
    </Form>
  );
};

export default DepartmentsAddModal;
